export const addNewOrderToStore = (state, order) => {
  return [order, ...state];
};

export const withdrawBalance = (state, amount) => {
  const userCopy = { ...state };
  userCopy.balanceRu -= amount;
  return userCopy;
};
